import type { Deck, DeckCard } from '@/types/deck';
import { useCallback } from 'react';
import useDeckCardOperations from './useDeckCardOperations';

export interface UseSetCommanderParams {
  deck: Deck | null;
  cards: DeckCard[] | null;
}

/**
 * Promote a deck card to the commander zone.
 * Partner-aware eviction of the sitting commander(s) lives in `useDeckCardOperations`.
 */
export default function useSetCommander({ deck, cards }: UseSetCommanderParams) {
  const { changeZone, isLoading } = useDeckCardOperations({
    deckId: deck?.id ?? '',
    isLocked: deck?.is_locked ?? false,
    deckFormat: deck?.format ?? null,
    allCards: cards ?? undefined,
  });

  const setCommander = useCallback(
    (cardId: string) => {
      if (!deck || !cards) return;
      changeZone(cardId, 'commander');
    },
    [deck, cards, changeZone],
  );

  return {
    setCommander,
    isLoading,
  };
}
